/* eslint-disable react-hooks/rules-of-hooks */
import { h } from 'preact';
import { useEffect } from 'preact/hooks';

import { doWidgetMutationInPage, doWidgetQueryInPage, doWidgetSubscriptionInPage } from './api';

export const useEffectsInPage = ({
  $root,
  authState,
  state,
  actions,
  pageActions,
  commonVariables,
  widget,
  handlers,
  parselyCommonState,
}) => {
  const isFirstQuery = !state.contents.length && !state.isMutationPending && !state.isMutationPrivacyPending;
  useEffect(() => {
    // Launch the query only at landing
    if (!authState.isLoginLoading && isFirstQuery) {
      doWidgetQueryInPage({
        actions,
        pageActions,
        commonVariables,
        widget,
        onSuccessCallback: () => {},
      });
    }

    // Any time the token change we launch the subscription
    if (authState.userToken) {
      doWidgetSubscriptionInPage({ actions, commonVariables, state, widget });
    }

    // It means the token has changed after a mutation request
    if (state.isMutationPending) {
      doWidgetMutationInPage({ actions, commonVariables, options: state.selectedOptions, widget });
    }

    // It means the token has changed after a privacy mutation request
    if (state.isMutationPrivacyPending) {
      handlers.handlePrivacyMutation(parselyCommonState.consentOptionSelected);
    }

    return () => {
      state.unsubscribe?.();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState.userToken]);
};
